import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

export function GuideThankYouPage() {
  useEffect(() => {
    console.log('Redirecting from /guide/thank-you to /thank-you');
  }, []);

  return <Navigate to="/thank-you" replace />;
}